import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation } from "@/mixins/index";
import { orderDiffDetail } from "@/api/dataAll/dataAll";
import viewDetils from "./components/viewDetils.vue";
export default {
  name: "detail",
  mixins: [serchSelect, tabulation],
  components: {
    viewDetils: viewDetils
  },
  data: function data() {
    return {
      more: true,
      value2: [],
      searchData: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      Dynamic: [],
      exportdataloading: false
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;
      orderDiffDetail(this.searchData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data || [];

          _this.tableData.forEach(function (item) {
            item;
          });

          _this.total = res.data.total;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      this.exportdataloading = true;
      orderDiffDetail(_objectSpread(_objectSpread({}, this.searchData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var columns = [{
            label: _this2.$t('game'),
            prop: "game"
          }, {
            label: _this2.$t('platform'),
            prop: "platform"
          }, {
            label: _this2.$t('channel'),
            prop: "channel"
          }];

          _this2.$export.excel({
            columns: columns,
            data: data,
            title: _this2.$route.meta.title
          });
        }
      }).finally(function () {
        _this2.exportdataloading = false;
      });
    }
  }
};